import { IProgramBookDownloadCreate } from 'src/types/programBookDownload';
import { ProgramBookDownloadFormData } from 'src/screens/General/screens/ProgramBook/screens/ProgramBookGraph/ProgramBookGraphScreen';
import moment from 'moment';

const groupProgramBookDownload = (
    dataForm: Partial<ProgramBookDownloadFormData>,
): Partial<IProgramBookDownloadCreate> => {
    const { dateFrom, dateTo, ...data } = dataForm;
    const dataSend: Partial<IProgramBookDownloadCreate> = { ...data };
    if (dateFrom) {
        dataSend.dateFrom = moment(dateFrom).format('YYYY-M-D');
    }
    if (dateTo) {
        dataSend.dateTo = moment(dateTo).format('YYYY-M-D');
    }
    return dataSend;
};
export { groupProgramBookDownload };
